const Img = ({src}: { src: string }) => {
    return <img src={src} alt={''} className="markdown-img"/>
}
export default Img;
